import React, { useState } from "react";
import { formatMoney } from "../utils/formatMoney";
import { MailOutlined } from '@ant-design/icons';
import { Button, Modal } from "antd";
import HelpCenter from "./HelpCneter";
import "../styles/components/plan.scss";
import "../styles/components/button.scss";

const Plan = props => {
  const [visible, setVisibility] = useState(false);

  const onUpgradeClick = (e) => {
    e.stopPropagation();
    Modal.info({
      content: <p dir="rtl" lang="fa" style={{ margin: 0 }}>{"امکان خرید یا ارتقای پلن غیرفعال شده است."}</p>,
      okText: "باشه",
    });
  };

  const isEnterprise = props.level === 10;

  return (
    <div
      className={`plan ${props.active ? "active" : ""} ${
        props.selected ? "selected" : ""
      }`}
      onClick={() => props.select(props.rawData)}
    >
      <div className={`title`}>{props.name}</div>
      <div className="price">
        {!isEnterprise ? (
          <>
            {formatMoney(props.price)}
            <sub>/mo</sub> {/* Always monthly */}
          </>
        ) : (
          <span role="img" aria-label="rocket">🚀</span>
        )}
      </div>
      {!props.selected || props.active || !props.salable || isEnterprise ? (
        undefined
      ) : (
        <Button
          type="primary"
          shape="round"
          size="medium"
          className="button-guest"
          onClick={onUpgradeClick}
        >
          Upgrade Plan
        </Button>
      )}
      {isEnterprise && props.selected ? (
        <Button
          icon={<MailOutlined />}
          shape="round"
          size="medium"
          className="button-guest"
          onClick={() => setVisibility(true)}
        >
          Contact us
        </Button>
      ) : (
        undefined
      )}

      <HelpCenter
        width={400}
        placement="left"
        closable={true}
        onClose={() => setVisibility(false)}
        visible={visible}
        name="contacts"
      />
      {props.active ? <p className="active-label">Active</p> : undefined}
    </div>
  );
};

export default Plan;
